module.exports = __webpack_public_path__ + "static/media/Startupknox_Icons_map.db54927e.png";